import React, { Component } from 'react';
// import { BGA, CONNECTOR } from '../../../../constants/componentType';
import { PACKAGE } from '../../../../constants/designType';
import './ExpandModelConnect.css';
import { Tooltip } from 'antd';

class ExpandModelConnect extends Component {

  scrollToAnchor = (comp) => {
    const { controller, device } = this.props;
    // this.props.scrollToAnchor(controller, device);
    this.props.changeNeedChangeComp(comp, comp === controller ? device : controller);
    // if (componentType === CONNECTOR || componentType === BGA) {
    //   this.props.scrollToAnchor(comp);
    //   this.props.changeNeedChangeComp(comp);
    // } else {
    //   const anchorElement = document.getElementById("andes-v2-component-table-container");
    //   if (anchorElement) {
    //     this.props.changeNeedChangeComp(comp);
    //     anchorElement.scrollIntoView();
    //   }
    // }
  }

  modelListRender = ({ key, type, modelList, comp, compType }) => {
    return modelList.map((model, index) => {
      return key !== "expand-model-title" && model.pairs.length === 0
        ? <div
          className={"comp-model-box" + (key !== "expand-model-title" && model.pairs.length === 0 ? " not-has-port" : "")}
          key={`${type}-package-${key}-${index}`}
        ></div>
        : <div
          className="comp-model-box"
          key={`${type}-package-${key}-${index}`}
          onClick={() => this.scrollToAnchor(comp, compType)}
        >
          {key === "expand-model-title"
            ? <div className='model-title'>{model.modelType}</div>
            : <>
              <div className='model-title' title={model.fileName}>
                {model.fileName}
              </div>
              {model.pairs.map((pairs, i) => (
                <div
                  className="net-box"
                  key={`${type}-package-${key}-${index}-${i}`}
                >
                  {this.portItemRender(pairs, `${type}-package-${key}-${index}-${i}`)}
                </div>
              ))}
            </>}
        </div>
    })
  }

  portItemRender = (pairs, keyPrefix) => {
    return pairs.map((pair, pairIndex) => (
      <div
        className={`port-name-not-select ${pair.node ? 'port-name-select' : ''}`}
        key={`${keyPrefix}-${pairIndex}`}
        title={`Port: ${pair.node || ""}`}
      >
        {pair.node || "Port"}
      </div>
    ))
  }

  layoutRender = (model, signalName, isPrelayout) => {
    if (!model) {
      return null;
    }

    if (isPrelayout) {
      return <>
        <div className='model-title' title={model.fileName}>
          {model.fileName}
        </div>
        {model.pairs.map((pairs, i) => (
          <div
            className="net-box "
            key={`layout-${i}`}
          >
            <div
              className={`port-name-not-select ${(pairs[0] || {}).node ? 'port-name-select' : ''}`}
              title={`Port: ${(pairs[0] || {}).node || ""}`}
            >
              {(pairs[0] || {}).node || "Port"}
            </div>
            <div title={`Signal: ${signalName}`}>{signalName}</div>
            <div
              className={`port-name-not-select ${(pairs[1] || {}).node ? 'port-name-select' : ''}`}
              title={`Port: ${(pairs[1] || {}).node || ""}`}
            >
              {(pairs[1] || {}).node || "Port"}
            </div>
          </div>
        ))}
      </>
    }

    return model.pairs.map((pins, i) => (
      <div
        className="net-box "
        key={`layout-${i}`}
      >
        <div
          className={`port-name-not-select ${(pins[0] || {}).pin ? 'port-name-select' : ''}`}
          title={`Pin: ${(pins[0] || {}).pin || ""}`}
        >
          {(pins[0] || {}).pin || ""}
        </div>
        <div title={`Signal: ${signalName}`}>{signalName}</div>
        <div
          className={`port-name-not-select ${(pins[1] || {}).pin ? 'port-name-select' : ''}`}
          title={`Pin: ${(pins[1] || {}).pin || ""}`}
        >
          {(pins[1] || {}).pin || ""}
        </div>
      </div>
    ))
  }

  getModelRenderParams = () => {
    const { modelList = {}, signalName, type, txModelTypes = {}, rxModelTypes = {}, txCompInfo = {}, rxCompInfo = {} } = this.props;
    if (type !== "expand-model-title") {
      return {
        key: signalName,
        txModelList: modelList.tx || [],
        rxModelList: modelList.rx || [],
        controllerType: txCompInfo.type,
        deviceType: rxCompInfo.type
      }
    } else {
      return {
        key: type,
        txModelList: txModelTypes,
        rxModelList: rxModelTypes
      }
    }
  }

  render() {
    const { type, controller, device, designType, modelList = {}, isPreLayout, signalName } = this.props;
    const { key, txModelList, rxModelList, controllerType, deviceType } = this.getModelRenderParams();

    return <div className={type === "expand-model-title" ? "expand-model-connect expand-model-connect-title" : "expand-model-connect"}>
      {/* connect line */}
      {/* {type !== "expand-model-title" ? <div className="line-box">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={`connect-line-${index}`}>
            {index === 0 ? <div className='model-title'></div> : null}
            <hr className="connect-line" />
          </div>
        ))}
      </div> : null} */}
      {/* Tx Package Model */}
      {this.modelListRender({ key, type: "tx", modelList: txModelList, comp: controller, compType: controllerType })}
      {/* PCB / Package */}
      <div className="pcb-box" onClick={(e) => this.props.clickPCBBox(e)} title="Click to collapse channel settings">
        {type === "expand-model-title"
          ? <div
            className='pcb-title-box'
            title="Click to collapse channel settings"
          >
            <span>{designType === PACKAGE ? "Package" : "PCB"}</span>
            <Tooltip title="The main layout">
              <i className="iconfont icon-icons8-circuit andes-v2-hspice-simulation-icon" />
            </Tooltip>
          </div>
          : this.layoutRender(modelList.layout, signalName, isPreLayout)
        }
      </div>
      {/* Rx Package Model */}
      {this.modelListRender({ key, type: "rx", modelList: rxModelList, comp: device, compType: deviceType })}
    </div>
  }
}

export default ExpandModelConnect;